import service from '@/services/SICUDgpd_pr_est';

export default {
  namespaced: true,

  state: {
    numberDocument: null,
    nit: null,
  },

  mutations: {
    SET_DATA_RESULT(state, data) {
      state.numberDocument = data.doc_num;
      state.nit = data.ter_nit;
    },
  },

  actions: {
    /**
     * Petición para obtener labels registrados en Integrity que serán utilizados en una vista.
     */
    async read({ commit, dispatch, rootGetters }, value) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDgpd_pr_est: {
            eeDatos: [rootGetters['auth/state']],
            eegpd_pr_est: [
              {
                doc_num: '',
                ter_nit: value.documentNumber,
                crd_apl1: value.lastName,
                crd_bol_ced: '',
                crd_ing: value.income,
              },
            ],
          },
        };

        let notification;

        service
          .post(payload)
          .then((response) => {
            const data = response.data.dsSICUDgpd_pr_est;

            if (data.eeEstados[0].Returnid === 0) {
              commit('SET_DATA_RESULT', data.eegpd_pr_est[0]);
              resolve(data);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },

    setDataResult({ commit }, data) {
      commit('SET_DATA_RESULT', data);
    },
  },

  getters: {
    state(state) {
      return {
        ...state,
      };
    },
  },
};
